import { Carrier } from "@/pages/mill/carriers/models/Carrier";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import {
	assemblyStatusCodes,
	CarrierAssemblyStatusTag,
} from "../components/CarrierAssemblyStatusTag";

type Props = {};
export const useTableData = ({}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "PartName",
			headerName: "Name",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "SectionName",
			headerName: "Section",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "StandName",
			headerName: "Stand",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "RollsetLetter",
			headerName: "Letter",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "TopRollName",
			headerName: "Top Roll",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "BottomRollName",
			headerName: "Bottom Roll",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "CarrierStatusCode",
			headerName: "Status",
			minWidth: 20,
			maxWidth: 70,
			flex: 1,
			valueGetter: (params) =>
				assemblyStatusCodes.find(
					(code) => code.Code === (params.data as Carrier).CarrierStatusCode,
				)?.Name,
			cellRenderer: CarrierAssemblyStatusTag,
			cellRendererParams: (params: ICellRendererParams) => ({
				status: assemblyStatusCodes.find(
					(code) => code.Code === (params.data as Carrier).CarrierStatusCode,
				),
			}),
		},
	];
	return { columnDefs };
};
